import styled from 'styled-components'

export const TableTitle = styled.p`
  padding-top: 8px;
  font-weight: bold;
`
